/* assets/wbn-recently-viewed.js - the "Recently Viewed" grid builder that used to be a
   33KB inline <script> in sections/recently-viewed.liquid (identical logic). It now starts
   from an IntersectionObserver on the section (300px ahead) instead of DOMContentLoaded.
   Liquid inputs come from data-* on .recently-viewed-section. */
(function () {
  var root = document.querySelector('[data-wbn-rv]');
  if (!root) return;
  var WBN_RV_API = root.getAttribute('data-api-base') || '';

function displayRecentlyViewed() {
  try {
    const productsGrid = document.getElementById('recently-viewed-products');
    const section = document.querySelector('.recently-viewed-section');
    
    // Use the existing theme-recent data from localStorage
    const themeRecent = localStorage.getItem('theme-recent');
    
    if (themeRecent) {
      const recentlyViewed = JSON.parse(themeRecent);
      
      // Get all product IDs from the single allProductIds array
      const allProductIds = recentlyViewed.allProductIds || [];
      
      if (allProductIds.length > 1) {
        // Skip the first product (current PDP) and show products 2-11 (10 products total)
        // Index 0: Current PDP (skip)
        // Index 1-10: Display these 10 products
        const productIdsToFetch = allProductIds.slice(1, 11);
        
       
        // Show the entire section and products grid
        section.style.display = 'block';
        section.style.opacity = '1';
        productsGrid.style.display = 'flex';
        
        // Fetch products from your backend API (keep original GraphQL IDs)
        fetchProductsFromAPI(productIdsToFetch, productsGrid);
      } else {
        // Hide the entire section if there are 1 or fewer products
        // (1 product = current PDP only, 0 products = no data)
        section.style.display = 'none';
      }
    } else {
      // Hide the entire section if no theme-recent data
      section.style.display = 'none';
    }
  } catch (error) {
    // Hide the entire section on error
    const section = document.querySelector('.recently-viewed-section');
    if (section) {
      section.style.display = 'none';
    }
  }
}
async function fetchProductsFromAPI(productIds, productsGrid) {
  try {
    // Validate input
    if (!productIds || productIds.length === 0) {
      throw new Error('No product IDs provided');
    }
    
    if (!Array.isArray(productIds)) {
      throw new Error('productIds must be an array');
    }
    
    const requestBody = {
      productIds: productIds
    };
    
    const response = await fetch(WBN_RV_API + '/api/products/details-by-ids', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    });
        
        if (!response.ok) {
      const errorText = await response.text();
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
    const apiResponse = await response.json();
    
    if (apiResponse.data && apiResponse.data.length > 0) {
      // Render products using the existing theme.buildProductGridItem function
      renderProductsFromAPI(apiResponse.data, productsGrid);
        } else {
      productsGrid.innerHTML = '<p style="text-align: center; color: #666;">No products found in API response</p>';
    }
        
      } catch (error) {
    // Show error message to user
    productsGrid.innerHTML = `
      <div style="text-align: center; color: #666; padding: 20px;">
        <p>Error loading products: ${error.message}</p>
          </div>
        `;
  }
}

function renderProductsFromAPI(products, productsGrid) {
  try {
    // Transform API data to match Shopify product format
    const transformedProducts = products.map(transformAPIProductToShopify);
    
    // Render products manually using our HTML generator
    const productHTML = transformedProducts.map(product => 
      generateProductHTML(product)
    ).join('');
    
    productsGrid.innerHTML = productHTML;
    
    // Initialize functionality after rendering
    initializeRecentlyViewedFunctionality();
    
  } catch (error) {
    productsGrid.innerHTML = `
      <div style="text-align: center; color: #666; padding: 20px;">
        <p>Error rendering products: ${error.message}</p>
        <p style="font-size: 12px; color: #999;">Check console for details</p>
      </div>
    `;
  }
}

function transformAPIProductToShopify(apiProduct) {
  // Transform API product data to match Shopify product format - ONLY necessary fields
  const firstVariant = apiProduct.variants.edges[0]?.node;
  const compareAtPrice = firstVariant?.compareAtPrice?.amount ? parseFloat(firstVariant.compareAtPrice.amount) * 100 : 0;
  const price = firstVariant?.price?.amount ? parseFloat(firstVariant.price.amount) * 100 : 0;



  // Transform variants - only keep necessary fields for product-grid-item
  const variants = apiProduct.variants.edges.map(edge => {
    const variantNode = edge.node;
    
    // Extract numeric ID from GraphQL ID for cart functionality
    let variantId = variantNode.id;
    if (typeof variantId === 'string' && variantId.includes('gid://')) {
      variantId = variantId.split('/').pop();
    }
    
    return {
      id: variantId, // Now contains just the numeric part for cart
      title: variantNode.title,
      available: variantNode.availableForSale,
      price: parseFloat(variantNode.price.amount) * 100,
      compare_at_price: variantNode.compareAtPrice?.amount ? parseFloat(variantNode.compareAtPrice.amount) * 100 : 0,
      image: variantNode.image?.url || '',
      option1: variantNode.selectedOptions[0]?.value || '',
      option2: variantNode.selectedOptions[1]?.value || '',
      option3: variantNode.selectedOptions[2]?.value || ''
    };
  });

  // Transform images - keep all images as product-grid-item might use them for gallery/variant images
  const images = apiProduct.images?.edges?.map(edge => ({
    url: edge.node.url,
    alt: edge.node.altText,
    width: edge.node.width,
    height: edge.node.height
  })) || [];

  // Transform options - essential for variant selection
  const options_with_values = apiProduct.options?.map(option => ({
    name: option.name,
    values: option.values
  })) || []; 

  return {
    id: apiProduct.id,
    title: apiProduct.title,
    handle: apiProduct.handle,
    url: `/products/${apiProduct.handle}`,
    
    // Featured image for main display
    featured_image: apiProduct.featuredImage?.url || '',
    featured_media: {
      preview_image: {
        src: apiProduct.featuredImage?.url || '',
        alt: apiProduct.featuredImage?.altText || apiProduct.title
      }
    },
    
    // All images for potential variant image display
    images: images,
    media: images.map(img => ({
      preview_image: {
        src: img.url,
        alt: img.alt,
        width: img.width,
        height: img.height
      }
    })),
    
    // Variants with only necessary fields
    variants: variants,
    
    // Options for variant selection
    options_with_values: options_with_values,
    
    // Availability and pricing
    available: apiProduct.availableForSale,
    price: price,
    price_min: price,
    price_max: price,
    compare_at_price: compareAtPrice,
    compare_at_price_min: compareAtPrice,
    compare_at_price_max: compareAtPrice,
    price_varies: apiProduct.variants.edges.length > 1,
    

    plpDescription: apiProduct.plpDescription || [],
    // Rating and reviews count
    rating: apiProduct.rating?.averageRating || 0,
    reviews_count: apiProduct.rating?.numberOfReviews || 0
  };
}

// Storefront API image URLs (`featuredImage.url`, `variant.image.url`)
// are the full-resolution original. Appending a width is the only thing that
// stops a 1000px+ master being served into a ~300px card. Every Storefront CDN
// URL carries `?v=`, so `&` has always worked here, but check anyway so a URL
// without a query string still produces a valid one.
function rvSizedImage(url, width) {
  if (!url) return '';
  return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
}

// ONE ladder definition, used by both the initial render and the
// `data-master*` attributes the swatch handler swaps in
// (snippets/il-custom-scripts.liquid). Keeping them identical is the point: it
// is what stops a swatch click from replacing a correctly-sized card image with
// something bigger, which is exactly the bug fixed for the PLP grid.
//
// The previous ladder declared width=150 as "300w" and width=300 as both "600w"
// and "800w". Those descriptors are what the browser selects on, so it always
// picked the 300px file and upscaled it — the card is 50vw on mobile (~206 CSS
// px at 412px, 541 device px at 2.625 DPR). Descriptors now match the real
// pixel widths, so the selected image matches the slot.
function rvImageLadder(url) {
  if (!url) return '';
  return [300, 400, 540].map(function (w) {
    return rvSizedImage(url, w) + ' ' + w + 'w';
  }).join(', ');
}

function generateProductHTML(product) {
  try {

    // Streamlined fallback HTML generation using ONLY necessary fields
    const variant = product.variants[0];
    const baseImageUrl = product.featured_image || '';
    // Inline data-URI fallback, was via.placeholder.com, an
    // external service with a history of outages, for something that only
    // needs to render when a product has no image at all. A data URI has
    // no network dependency whatsoever - it can't fail regardless of
    // whether any third party (or even our own CDN) is reachable.
    const imageUrl = baseImageUrl
      ? rvSizedImage(baseImageUrl, 540)
      : 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'300\' height=\'200\'%3E%3Crect width=\'100%25\' height=\'100%25\' fill=\'%23f0f0f0\'/%3E%3Ctext x=\'50%25\' y=\'50%25\' text-anchor=\'middle\' dy=\'.3em\' fill=\'%23999\' font-family=\'sans-serif\' font-size=\'16\'%3ENo Image%3C/text%3E%3C/svg%3E';

    // Generate srcset for responsive images
    const imageSrcset = rvImageLadder(baseImageUrl);

    // Alt text mirrors snippets/product-image-alt.liquid: the Shopify media alt
    // (`featuredImage.altText`) first, then the product title as the default.
    const imageAlt = String(
      (product.featured_media && product.featured_media.preview_image && product.featured_media.preview_image.alt)
        || product.title
        || ''
    ).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // Derive numeric product id from GraphQL gid if needed
  const numericProductId = (product.id && typeof product.id === 'string' && product.id.indexOf('gid://') === 0)
    ? product.id.split('/').pop()
    : product.id;
  
  let currentPrice = '';
  let originalPrice = '';
  let discount = '';
  
  if (product.price_varies) {
    currentPrice = `₹${(product.price_min / 100).toFixed(0)}`;
  } else {
    currentPrice = `₹${(product.price / 100).toFixed(0)}`;
  }
  
  if (product.compare_at_price && product.compare_at_price > product.price) {
    originalPrice = `₹${(product.compare_at_price / 100).toFixed(0)}`;
    const discountPercent = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
    discount = `Save ${discountPercent}%`;
  }
  
  const isAvailable = product.available;
  const buttonText = isAvailable ? 'Add to Cart' : 'Notify Me';
  

  
  // Generate pack options if product has multiple variants
  let packOptions = '';
  if (product.variants && product.variants.length > 1) {
    packOptions = `
      <div class="buttonize" data-formid="recently-viewed-${product.id}">
        <label class="show">Pack:</label>
        ${product.variants.map((variant, index) => {
          const variantDiscount = variant.compare_at_price && variant.compare_at_price > variant.price ? 
            `Save ${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}%` : '';
          
          const packText = (variant.title || `Pack ${index + 1}`)
            .replace(/Pack of /gi, '')
            .replace(/^.*\s\/\s(\d+)$/, '$1');

          // this used to emit the raw Storefront URL (the full-resolution
          // original) as data-master, with no data-master-srcset sibling.
          // snippets/il-custom-scripts.liquid copies data-master into the card
          // image's src and data-master-srcset into its srcset, and
          // ait-membership.js clicks the active swatch on DOMContentLoaded — so it
          // fired on every page load with no user interaction. Measured on the PLP
          // equivalent before four masters, 298 KB, arriving at +10.7s,
          // inside the LCP window. With no data-master-srcset the handler falls
          // back to writing the bare URL into srcset, which strips every width
          // descriptor and disables responsive selection outright.
          const swatchImage = variant.image || product.featured_image;

          return `<a class="eee bze-option ${index === 0 ? 'active' : ''}"
                 data-discount="${variantDiscount}"
                 data-variantid="${variant.id}"
                 data-varprice="₹${(variant.price / 100).toFixed(0)}"
                 data-varsaleprice="${variant.compare_at_price ? `₹${(variant.compare_at_price / 100).toFixed(0)}` : ''}"
                 data-master="${rvSizedImage(swatchImage, 540)}"
                 data-master-srcset="${rvImageLadder(swatchImage)}">
            ${packText}
          </a>`;
        }).join('')}
      </div>
    `;
  } else {
    // Add empty space to maintain consistent card height when no pack options
    packOptions = `
      <div class="buttonize empty-pack-space" data-formid="recently-viewed-${product.id}">
        <div style="height: 24px;"></div>
      </div>
    `;
  }
  
  // Generate PLP description tags
  let plpTags = '';
  if (product.plpDescription && product.plpDescription.length > 0) {
    plpTags = `
      <div class="plp_tags_container" data-tags="${product.plpDescription.join(',')}">
        ${product.plpDescription.map(tag => `<span class="plp_product_tags">${tag}</span>`).join('')}
      </div>
    `;
  }
  
  // Generate rating display
  let ratingDisplay = '';
  if (product.rating && product.reviews_count) {
    ratingDisplay = `
      <div class="grid-product__tag grid-product__review">
        <a href="${product.url}#judgeme_reviews" class="rating-link" style="text-decoration: none; color: inherit;">
          ★ ${product.rating}/5 (${product.reviews_count})
        </a>
      </div>
    `;
  } else {
    ratingDisplay = `
      <div class="grid-product__tag grid-product__review">
        <span class="no-reviews">★ No Reviews</span>
      </div>
    `;
  }
  

  
  const html = `
    <div class="grid__item grid-product">
    <div class="grid-product__content">
      <div class="grid-product__content-wrapper">
        <div class="grid__item-image-wrapper">
          <div class="grid-product__image-mask">
            <a class="urlsec-link" href="${product.url}" aria-label="${product.title}"><span class="u-hidden"  >${product.title}</span></a>
            <div class="grid__image-ratio grid__image-ratio--square">
              <img src="${imageUrl}" 
                  ${imageSrcset ? `srcset="${imageSrcset}"` : ''}
                  sizes="(max-width: 767px) 50vw, (max-width: 1024px) 33vw, 25vw"
                  alt="${imageAlt}" 
                  class="grid-product__image image-style--square"
                  width="300"
                  height="300"
                  loading="lazy">
            </div>
          </div>
        </div>

        <div class="recently-viewed-info__section">
          <a href="${product.url}" class="grid-product__link" aria-label="${product.title}">
          <div class="grid-product__meta">
              ${packOptions}
              
              ${ratingDisplay}
              
              <div class="grid-product__title_description_tags">
            <div class="grid-product__title grid-product__title--body">
              <a href="${product.url}" class="grid-product__title-link" aria-label="${product.title}">${product.title}</a>
            </div>
                
                ${plpTags}
            
            <div class="grid-product__price">
              <span class="main-price">${currentPrice}</span>
              <span class="grid-product__price--original">${originalPrice ? originalPrice : ''}</span>
                   <span class="grid-product__price--savings">${discount ? discount : ''}</span>
                </div>
            </div>
              
          </div>
        </a>
        
        <div class="addtocart_buttonsec">
          ${isAvailable ? 
            `<button class="add-to-cart cartAdd_btn" 
                    data-variant-id="${product.variants && product.variants.length > 0 ? product.variants[0].id : 'no-variant'}"
                    data-product-handle="${product.handle}"
                    data-product-title="${product.title}">
              ${buttonText}
            </button>` :
            `<button class="notifyMe_buttonsec notifyMe_btn" 
                    data-product='${JSON.stringify({
                      id: product.id,
                      title: product.title,
                      variant_price: product.variants && product.variants.length > 0 ? product.variants[0].price : 0,
                      variant_compare_at_price: product.variants && product.variants.length > 0 ? product.variants[0].compare_at_price || 0 : 0,
                      handle: product.handle,
                      vendor: product.vendor || '',
                      product_type: product.type || '',
                      variant_id: product.variants && product.variants.length > 0 ? product.variants[0].id : '',
                      variant_title: product.variants && product.variants.length > 0 ? product.variants[0].title : '',
                      sku: product.variants && product.variants.length > 0 ? product.variants[0].sku || '' : '',
                      image: product.featured_image || '',
                      url: product.url || '',
                      price_varies: product.price_varies || false,
                      price_min: product.price_min || 0,
                      compare_at_price: product.compare_at_price || 0,
                      price: product.price || 0
                    })}' 
                    data-variant-id="${product.variants && product.variants.length > 0 ? product.variants[0].id : 'no-variant'}"
                    onclick="notifyMe(this)">
              ${buttonText}
            </button>`
          }
        </div>
        </div>
        </div>
      </div>
    </div>
  `;
  
  return html;
  
  } catch (error) {
    return `
      <div class="grid__item grid-product">
        <div style="text-align: center; color: #666; padding: 20px;">
          <p>Error rendering product: ${product.title || 'Unknown'}</p>
          <p style="font-size: 12px; color: #999;">${error.message}</p>
        </div>
      </div>
    `;
  }
}

// Initialize functionality after products are rendered
function initializeRecentlyViewedFunctionality() {
  // Initialize pack selection functionality
  initializePackSelection();
  
  // Initialize add to cart functionality
  initializeAddToCart();

  // Initialize wishlist hearts for recently viewed cards
  initializeWishlistHeartsForRecentlyViewed();
}

function initializePackSelection() {
  // Add click event listeners to pack options
  document.querySelectorAll('.recently-viewed-grid .bze-option').forEach(option => {
    option.addEventListener('click', function(e) {
      e.preventDefault();
      
      const productCard = this.closest('.grid-product');
      const variantId = this.dataset.variantid;
      const price = this.dataset.varprice;
      const comparePrice = this.dataset.varsaleprice;
      const image = this.dataset.master;
      const discount = this.dataset.discount;
      
      // Update active state
      productCard.querySelectorAll('.bze-option').forEach(opt => opt.classList.remove('active'));
      this.classList.add('active');
      
      // Update prices
      const priceContainer = productCard.querySelector('.grid-product__price');
      const currentPriceEl = priceContainer.querySelector('.main-price');
      const originalPriceEl = priceContainer.querySelector('.grid-product__price--original');
      const discountEl = priceContainer.querySelector('.grid-product__price--savings');
      
      if (currentPriceEl) {
        currentPriceEl.textContent = price;
      }
      
      if (discount && comparePrice) {
        originalPriceEl.textContent = comparePrice;
        originalPriceEl.classList.remove('hide');
      } else if (originalPriceEl) {
        originalPriceEl.classList.add('hide');
      //  productCard.find('.grid-product__price--original').style.display = 'none';
        
      }
      
      if (discountEl && discount) {
        discountEl.textContent = discount;
        discountEl.classList.remove('hide');
      } else if (discountEl) {
        discountEl.classList.add('hide');
      }
      
      // Update product image
      if (image) {
        const productImage = productCard.querySelector('.grid-product__image');
        if (productImage) {
          productImage.style.opacity = '0.5';
          setTimeout(() => {
            productImage.src = image;
            productImage.style.opacity = '1';
          }, 150);
        }
      }
      
      // Update add to cart button variant ID
      const addToCartBtn = productCard.querySelector('.add-to-cart');
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = variantId;
      }
      
      // Update notify me button variant ID if it exists
      const notifyMeBtn = productCard.querySelector('.notifyMe_btn');
      if (notifyMeBtn) {
        notifyMeBtn.dataset.variantId = variantId;
      }

      // Update wishlist button variant ID if it exists
      const wishlistBtn = productCard.querySelector('.recently-viewed-wishlist-toggle-btn');
      if (wishlistBtn) {
        wishlistBtn.setAttribute('data-variant-id', variantId);
      }
    });
  });
}

function initializeAddToCart() {
  // Add click event listeners to add to cart buttons
  document.querySelectorAll('.recently-viewed-grid .add-to-cart').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const variantId = this.dataset.variantId;
      const productHandle = this.dataset.productHandle;
      const productTitle = this.dataset.productTitle;
      
      if (!variantId || variantId === 'undefined' || variantId === 'null') {
        alert('Please select a pack option first');
        return;
      }
      
      // Add to cart functionality
      addToCartFromRecentlyViewed(variantId, productTitle, this);
    });
  });
  
  // Add click event listeners to notify me buttons
  document.querySelectorAll('.recently-viewed-grid .notifyMe_btn').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      // The notifyMe function will be called via onclick attribute
      // This is just for any additional functionality you might want to add
    });
  });
}

async function addToCartFromRecentlyViewed(variantId, productTitle, button) {
  try {
    // Show loading state
    button.textContent = 'Adding...';
    button.disabled = true;
    
    // Parse variant ID to ensure it's a number
    const parsedVariantId = parseInt(variantId);
    
    if (isNaN(parsedVariantId)) {
      throw new Error(`Invalid variant ID: ${variantId}`);
    }
    
    // Add to cart using Shopify AJAX API
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parsedVariantId,
          quantity: 1
        }]
      })
    });
    
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to add product to cart: ${response.status} ${response.statusText}`);
    }
    
    const result = await response.json();
    
    // Success - update button
    button.textContent = 'Added!';
    button.style.background = '#7db4aa';
    button.style.color = '#fff';
    
    // Reset button after delay
    setTimeout(() => {
      button.textContent = 'Add to Cart';
      button.style.background = '';
      button.style.color = '';
      button.disabled = false;
    }, 2000);
    
    // Trigger cart update event
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { variantId, productTitle }
    }));
    
    // Update cart count if your theme has this function
    if (typeof updateCartCount === 'function') {
      updateCartCount();
    }
    
  } catch (error) {
    // Reset button on error
    button.textContent = 'Add to Cart';
    button.disabled = false;
    
    // Show error message
    alert('Failed to add product to cart. Please try again.');
  }
}
/**
 * Initialize wishlist hearts within recently viewed grid
 */
function initializeWishlistHeartsForRecentlyViewed() {
  const API_BASE_URL = WBN_RV_API;
  const WISHLIST_ENDPOINT = '/api/wishlist';
  const WISHLIST_LIST_ENDPOINT = '/api/wishlist/list';

  const grid = document.getElementById('recently-viewed-products');
  if (!grid) return;

  const buttons = grid.querySelectorAll('.recently-viewed-wishlist-toggle-btn');
  if (!buttons || !buttons.length) return;

  // Attach click handlers
  buttons.forEach((btn) => {
    if (btn.dataset.wishlistBound === '1') return;
    btn.dataset.wishlistBound = '1';
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      if (btn.disabled) return;

      const productId = btn.getAttribute('data-product-id');
      const variantId = btn.getAttribute('data-variant-id');
      const icon = btn.querySelector('svg');
      const isActive = icon && (icon.getAttribute('fill') === 'red' || icon.classList.contains('active') || btn.classList.contains('wishlist-active'));

      try {
        btn.disabled = true;
        if (icon) icon.style.opacity = '0.5';

        const customerId = getCustomerIdForWishlist();
        if (!customerId) {
          if (typeof window.triggerLoginWrapper === 'function') {
            window.triggerLoginWrapper();
          }
          throw new Error('User not logged in');
        }

        if (!variantId) {
          throw new Error('Missing variant id');
        }

        if (!isActive) {
          // Add to wishlist
          const resp = await fetch(`${API_BASE_URL}${WISHLIST_ENDPOINT}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              customerId: String(customerId),
              productId: String(productId || ''),
              variantId: String(variantId),
              sourcePlatform: 'web',
              sourceAction: 'direct'
            })
          });
          if (!resp.ok && resp.status !== 409) {
            const errText = await resp.text();
            throw new Error(`Add failed ${resp.status}: ${errText}`);
          }

          btn.classList.add('wishlist-active');
          if (icon) {
            icon.classList.add('active');
            icon.setAttribute('fill', 'red');
          }
          if (typeof window.showToast === 'function') {
            window.showToast(resp.status === 409 ? 'Product is already in your wishlist!' : 'Product added to Wishlist', resp.status === 409 ? 'info' : 'success');
          }
        } else {
          // Remove from wishlist
          const params = new URLSearchParams({ variantId: String(variantId), productId: String(productId || ''), sourcePlatform: 'web' });
          const resp = await fetch(`${API_BASE_URL}${WISHLIST_ENDPOINT}/${String(customerId)}/?${params.toString()}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
          });
          if (!resp.ok) {
            const errText = await resp.text();
            throw new Error(`Remove failed ${resp.status}: ${errText}`);
          }

          btn.classList.remove('wishlist-active');
          if (icon) {
            icon.classList.remove('active');
            icon.setAttribute('fill', 'none');
          }
          if (typeof window.showToast === 'function') {
            window.showToast('Product Removed From Wishlist', 'success');
          }
        }
      } catch (err) {
        // silently fail and revert visual state
      } finally {
        btn.disabled = false;
        const icon = btn.querySelector('svg');
        if (icon) icon.style.opacity = '1';
      }
    });
  });

  // Sync active states from API for logged-in users
  const customerId = getCustomerIdForWishlist();
  if (!customerId) return;
  try {
    fetch(`${API_BASE_URL}${WISHLIST_LIST_ENDPOINT}/${String(customerId)}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json', 
        Accept: 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((payload) => {
        if (!payload || !Array.isArray(payload.customerProductIds)) return;
        const ids = payload.customerProductIds.map(String);
        buttons.forEach((btn) => {
          const productId = btn.getAttribute('data-product-id');
          const icon = btn.querySelector('svg');
          const active = productId && ids.includes(String(productId));
          if (active) {
            btn.classList.add('wishlist-active');
            if (icon) {
              icon.classList.add('active');
              icon.setAttribute('fill', 'red');
            }
          } else {
            btn.classList.remove('wishlist-active');
            if (icon) {
              icon.classList.remove('active');
              icon.setAttribute('fill', 'none');
            }
          }
        });
      })
      .catch(() => {});
  } catch (_) {}
}

function getCustomerIdForWishlist() {
  try {
    if (typeof window !== 'undefined' && window.customer && window.customer.id) {
      return String(window.customer.id);
    }
  } catch (_) {}
  try {
    const kp = localStorage.getItem('kp_customer_id');
    return kp || null;
  } catch (_) {
    return null;
  }
}

// Listen for cart:close events to refresh wishlist state in recently viewed products
document.addEventListener('DOMContentLoaded', function() {
  // Listen for cart:close event to refresh recently viewed wishlist states
  document.addEventListener('cart:close', function() {
    try {
      // Refresh wishlist states for recently viewed products after cart closes
      // This handles cases where items were moved from cart to wishlist
      refreshRecentlyViewedWishlistStates();
    } catch (error) {
      console.warn('Error refreshing recently viewed wishlist states on cart close:', error);
    }
  });
});

// Function to refresh wishlist states for recently viewed products
function refreshRecentlyViewedWishlistStates() {
  const API_BASE_URL = WBN_RV_API;
  const WISHLIST_LIST_ENDPOINT = '/api/wishlist/list';
  
  const grid = document.getElementById('recently-viewed-products');
  if (!grid) return;

  const buttons = grid.querySelectorAll('.recently-viewed-wishlist-toggle-btn');
  if (!buttons || !buttons.length) return;

  const customerId = getCustomerIdForWishlist();
  if (!customerId) return;

  try {
    fetch(`${API_BASE_URL}${WISHLIST_LIST_ENDPOINT}/${String(customerId)}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json', 
        Accept: 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((payload) => {
        if (!payload || !Array.isArray(payload.customerProductIds)) return;
        const ids = payload.customerProductIds.map(String);
        buttons.forEach((btn) => {
          const productId = btn.getAttribute('data-product-id');
          const icon = btn.querySelector('svg');
          const active = productId && ids.includes(String(productId));
          if (active) {
            btn.classList.add('wishlist-active');
            if (icon) {
              icon.classList.add('active');
              icon.setAttribute('fill', 'red');
            }
          } else {
            btn.classList.remove('wishlist-active');
            if (icon) {
              icon.classList.remove('active');
              icon.setAttribute('fill', 'none');
            }
          }
        });
      })
      .catch(() => {
        // Silently handle errors to avoid breaking functionality
      });
  } catch (_) {
    // Silently handle errors to avoid breaking functionality
  }
}

  function wbnStart() { try { displayRecentlyViewed(); } catch (e) {} }
  /* The section itself is display:none until it has products, so observe its Shopify
     wrapper (zero-height boxes still report isIntersecting once inside the root bounds). */
  var target = document.getElementById('shopify-section-' + (root.getAttribute('data-section-id') || '')) || root;
  if (!('IntersectionObserver' in window)) { wbnStart(); return; }
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting || entries[i].intersectionRatio > 0) { io.disconnect(); wbnStart(); return; }
    }
  }, { rootMargin: '300px 0px' });
  io.observe(target);
})();
